import {Button, Drawer, Result} from "antd";
import {CloseOutlined} from "@ant-design/icons";
import {ServiceOrderDrawerOrderInfo} from ".";
import moment from "moment";
import {mapStatusIdToStatus} from "../../../list/list";
import {SetSelectedStoreServiceOrderInfoPayload} from "../../../../../../../service-feature/useCases/get-orders/reducers";
import {useGetStoreServiceOrderApi} from "../../../../../../../react-query-hooks/store/services/get-store-service-order";
import {FullPageLoader} from "../../../../../../full-page-loader";
import {StyledStoreServiceOrderDrawer} from "../../../customer/drawer/styles";

type StoreServiceOrderDrawerProps = {
  orderDetails: SetSelectedStoreServiceOrderInfoPayload | null;
  openOrderInfoDrawer: boolean;
  onOrderInfoDrawerClose: () => void;
};

// Delivered on July 16, 2025

export function StoreServiceOrderDrawer({
  orderDetails,
  onOrderInfoDrawerClose,
  openOrderInfoDrawer,
}: StoreServiceOrderDrawerProps) {
  // const {
  //   state: {storeServiceOrderData},
  // } = useGetStoreServiceOrderContext();
  const getStoreServiceOrderQuery = useGetStoreServiceOrderApi(orderDetails?.id);
  if (!orderDetails) return null; // or show a loader/skeleton

  return (
    <StyledStoreServiceOrderDrawer
      title={orderDetails.productService.name}
      placement="right"
      onClose={onOrderInfoDrawerClose}
      visible={openOrderInfoDrawer}
      closable={false}
      extra={
        <Button size="small" type="text" onClick={onOrderInfoDrawerClose}>
          <CloseOutlined />
        </Button>
      }
    >
      {getStoreServiceOrderQuery.isLoading ? (
        <FullPageLoader />
      ) : getStoreServiceOrderQuery.isError ? (
        <Result
          status="500"
          title="Sorry, something went wrong."
          subTitle="Error fetching order"
          extra={
            <Button
              type="primary"
              size="small"
              onClick={() => getStoreServiceOrderQuery.refetch()}
            >
              Try again
            </Button>
          }
        />
      ) : (
        // Order-level fields come from the selected list item (orderDetails);
        // the detail query supplies only the work-delivery submissions.
        <ServiceOrderDrawerOrderInfo
          orderTime={`Ordered ${moment(orderDetails.createdAt).fromNow()}`}
          status={mapStatusIdToStatus(orderDetails.statusId)}
          customerEmail={orderDetails.emailAddress}
          customerName={`${orderDetails.firstName} ${orderDetails.lastName}`}
          deliveryInfo={moment(orderDetails.delivery_date).format("MMMM DD, YYYY")}
          price={
            +orderDetails.amount > 0
              ? `${orderDetails.currency} ${orderDetails.amount}`
              : "Free"
          }
          productServiceDeliveries={
            getStoreServiceOrderQuery.data.order.productServiceDeliveries
          }
        />
      )}
    </StyledStoreServiceOrderDrawer>
  );
}
